import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-removemarketoffer',
  templateUrl: './removemarketoffer.component.html',
  styleUrls: ['./removemarketoffer.component.css']
})
export class RemovemarketofferComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
